module.exports = __webpack_public_path__ + "img/2_caaf60aa8.png";